<template>
  <v-container>
    <v-container class="d-flex justify-center">
      <div class="headline">
        <b>  </b>
      </div>
    </v-container>
    <v-alert type="info" v-if="loading_user" :value="true">
      Carregando...
      <v-progress-linear color="white" :indeterminate="true"></v-progress-linear>
    </v-alert>
    <v-expansion-panels popout multiple v-if="!loading_user" v-model="panel">
      <v-expansion-panel id="main-data">
        <v-expansion-panel-header>Informações Básicas</v-expansion-panel-header>
        <v-expansion-panel-content>

          <show-main-data></show-main-data>

        </v-expansion-panel-content>
      </v-expansion-panel>

    </v-expansion-panels>
  </v-container>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import Api from '@/api/index'

export default {
  name: 'ShowUserRegister',
  components: {
    ShowMainData: () => import('./show/ShowMainData'),
  },
  data() {
    return {
      panel: [0, 1],
      loading_user: true,
      loading_department: false,
      // loading_associations: false,
      // loading_contacts: false,
      // loading_bank_accounts: false,
    }
  },
  mounted () {
    this.showOneUser(this.$route.params.id).then( async (r)=>{
      try {
        // await this.getAssociations(this.$route.params.id)
        // await this.getAddress(this.$route.params.id)
        // await this.getContacts(this.$route.params.id)
        this.loading_user = false
      } catch (error) {
        throw new Error(error)
      }
    }).catch(err=>{
      console.log({err});
    })
  },
  beforeDestroy() {
    this.clearOneUser()
  },
  methods: {
    ...mapActions({
      showOneUser: 'User/showOneUser',
      clearOneUser: 'User/clearOneUser',
    }),
    ...mapMutations({
      setAssociations: 'User/setAssociations',
      setAddress: 'User/setUserAddress',
      // setContacts: 'User/setUserContacts',
      // setBankAccounts: 'User/setUserBankAccounts',
    })
  },
  computed: {
    ...mapState({
      one_user: state => state.User.oneUser
    })
  },
}
</script>

<style lang="scss" scoped>

</style>
